import { useContext } from 'react';
import {
  DateTimeFormatContext,
  DateTimeFormatProviderData
} from './DateTimeFormatProvider';

export const useMeDateTimeFormats = (): DateTimeFormatProviderData =>
  useContext(DateTimeFormatContext) as DateTimeFormatProviderData;
